import { Icon } from "@nju/icons";
import { Text } from "@nju/ui";
import { IHeaderMenuItemProps } from "../types";
import { HeaderMenuMobileContentItemLink } from "./HeaderMenuMobileContentItemLink";

export function HeaderMenuMobileContentItem({
  icon,
  links,
  title,
  additionalIcon,
}: IHeaderMenuItemProps) {
  const mapLinks = links.map((itemLink, indexLink) => {
    return (
      <HeaderMenuMobileContentItemLink
        key={`headerMenuItemLink_${indexLink}`}
        tabTitle={title}
        {...itemLink}
      />
    );
  });

  return (
    <div>
      <div className="flex gap-3 items-center justify-start pt-5 pb-4">
        {(icon || additionalIcon) && (
          <div className="flex gap-1 items-center">
            {icon && (
              <Icon
                data-cy="agent-menu-button"
                height={24}
                name={icon}
                tone="accent"
                width={24}
              />
            )}
            {additionalIcon && (
              <div className="flex gap-1 items-center">
                <Text size="l" tone="accent">
                  +
                </Text>
                <Icon
                  height={24}
                  name={additionalIcon}
                  tone="accent"
                  width={24}
                />
              </div>
            )}
          </div>
        )}
        <Text size="l" tone="accent">
          {title}
        </Text>
      </div>
      <div className="flex flex-col flex-wrap h-full border-l-1 border-geyser ml-[12px]">
        {mapLinks}
      </div>
    </div>
  );
}
